const privacyContent = [
    {
      id: 1,
      title: 'Welche Daten wir erfassen',
      content: `Wenn Sie unseren Newsletter abonnieren, erfassen wir Ihre E-Mail-Adresse, um Ihnen Updates, Aktionen und Neuigkeiten rund um Pizza Time zu senden. Weitere personenbezogene Daten erfassen wir nur, wenn Sie uns diese freiwillig zur Verfügung stellen, z. B. bei einer Kontaktaufnahme.`
    },
    {
      id: 2,
      title: 'Wie wir Ihre Daten verwenden',
      content: `Wir verwenden Ihre E-Mail-Adresse zu folgenden Zwecken:
  
  - Versand unseres Newsletters, Sonderangebote und Neuigkeiten über unsere Pizzeria.
  - Verbesserung unserer Kommunikation und Bereitstellung relevanter Inhalte.
  - Einhaltung gesetzlicher und behördlicher Vorgaben, sofern erforderlich.
  
  Wir **verwenden** Ihre E-Mail-Adresse **nicht** für andere Zwecke und Sie können sich jederzeit abmelden.`
    },
    {
      id: 3,
      title: 'Ihre Rechte gemäß DSGVO',
      content: `Als Website mit Sitz in der EU haben Sie folgende Rechte in Bezug auf Ihre personenbezogenen Daten:
  
  - **Auskunftsrecht**: Sie können jederzeit eine Kopie Ihrer Daten anfordern.
  - **Recht auf Berichtigung**: Wenn Ihre Daten falsch sind, können Sie eine Korrektur verlangen.
  - **Recht auf Löschung**: Sie können die Löschung Ihrer E-Mail-Adresse verlangen, indem Sie sich vom Newsletter abmelden oder uns kontaktieren.
  - **Widerspruchsrecht**: Sie können dem Erhalt von Marketingnachrichten jederzeit widersprechen.
  
  Um diese Rechte auszuüben, kontaktieren Sie uns unter **casa.itzling@gmail.com**.`
    },
    {
      id: 4,
      title: 'Dienste von Drittanbietern',
      content: `Wir können Dienste von Drittanbietern zur Verwaltung unserer E-Mail-Abonnements nutzen (z. B. Mailchimp oder ähnliche Plattformen). Diese Dienste erfüllen die Anforderungen der DSGVO und verarbeiten Ihre Daten ausschließlich zum Versand unseres Newsletters.
  
  Wir **verkaufen**, **vermieten** oder **teilen** Ihre E-Mail-Adresse **nicht** mit Dritten zu Werbezwecken oder anderen nicht verwandten Zwecken.`
    },
    {
      id: 5,
      title: 'Datensicherheit',
      content: `Wir nehmen den Schutz Ihrer Daten ernst und setzen geeignete Maßnahmen ein, um Ihre E-Mail-Adresse vor unbefugtem Zugriff oder Missbrauch zu schützen. Allerdings ist keine Online-Datenübertragung zu 100 % sicher. Wenn Sie Bedenken hinsichtlich Ihrer Privatsphäre haben, kontaktieren Sie uns bitte.`
    },
    {
      id: 6,
      title: 'Änderungen dieser Datenschutzerklärung',
      content: `Wir können diese Datenschutzerklärung gelegentlich aktualisieren, um neuen Vorschriften zu entsprechen oder unsere Services zu verbessern. Bei wesentlichen Änderungen informieren wir Sie über unsere Website oder per E-Mail.
  
  Diese Erklärung wurde zuletzt am **17. Februar 2025** aktualisiert.`
    }
  ];
  
  export default privacyContent;
  
